var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Clinker"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy",
    cx: 10,
    cy: 2,
    r: 2,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 4",
    cx: 10,
    cy: 10,
    r: 2,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 2",
    cx: 6,
    cy: 6,
    r: 2,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 3",
    cx: 2,
    cy: 10,
    r: 2,
    fill: "#00374D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinker);
export default __webpack_public_path__ + "static/media/clinker.efd17d2e7370582d02f022cb0493bd73.svg";
export { ForwardRef as ReactComponent };